/**
 * Activity Log
 */
import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const ActivityLogState = {
  activityLog: {
    activityLogOverlay: false,
    events: [],
    showDialog: false,
  },
}

export const ActivityLogActions = {
  fetchActivityLogs: async ({ commit }, { recordId }) => {
    commit('setActivityLogOverlay', true)
    return axiosRequest.
      get(`/records/${recordId}/audit_logs`).
      then(({ data }) => {
        commit('setActivityLogEvents', data.audit_logs)
        commit('setActivityLogOverlay', false)
      }).
      catch(handleError)
  },

  handleOnActivityLog: ({ commit }, { showDialog }) => {
    commit('setOnActivityLog', showDialog)
  },

  resetActivityLog: ({ commit }) => {
    commit('resetActivityLog')
  },

  showActivityLogDialog: ({ commit }, req) => {
    commit('setShowActivityLogDialog', req)
  },
}

export const ActivityLogMutations = {
  resetActivityLog: state => {
    state.activityLog.activityLogOverlay = false
    state.activityLog.events = []
    state.activityLog.showDialog = false
  },
  setActivityLogEvents: (state, payload) => {
    const entries = payload || []
    state.activityLog.events = entries.sort((a, b) => b.id - a.id)
  },
  setActivityLogOverlay: (state, payload) => {
    state.activityLog.activityLogOverlay = payload
  },
  setOnActivityLog: (state, showDialog) => {
    state.activityLog.showDialog = showDialog
  },
  setShowActivityLogDialog: (state, payload) => {
    state.activityLog.showDialog = payload.showDialog
  },
}

export const ActivityLogGetters = {
  activityLogOverlay: state => state.activityLog.activityLogOverlay,
  events: state => state.activityLog.events,
  showDialogActivityLog: state => state.activityLog.showDialog,
}
